import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

export interface QueryUsersForBusinessExportArgs {
  businessId: string
  cursor?: string
  excludeRemovedUsers?: boolean
  /** UK payroll columns are only written for tenants that have them, so only they pay for the fields. */
  includeEmploymentDetails?: boolean
}

/**
 * The people CSV export walks every user in a tenant, so it selects only the columns it
 * writes rather than the `fullUser` fragment the other list queries share — that fragment
 * carries ~50 fields per user, all of which would be paid for on every page.
 */
export const usersForBusinessExportQuery = gql`
  query UsersForBusinessExport(
    $businessId: ID!
    $cursor: String
    $excludeRemovedUsers: Boolean
    $includeEmploymentDetails: Boolean = false
  ) {
    usersForBusiness(businessId: $businessId, cursor: $cursor, excludeRemovedUsers: $excludeRemovedUsers) {
      cursor
      results {
        firstName
        lastName
        email
        dateOfBirth {
          day
          month
          year
        }
        externalStartDate
        externalEmployeeId
        employmentDetails @include(if: $includeEmploymentDetails) {
          ni_number
          probation_end_date
          job_grade
          termination_date
          hours_per_week
          annual_gross_salary
          pay_frequency
        }
      }
    }
  }
`

export const usersForBusinessExportKey = getQueryNames(usersForBusinessExportQuery)[0]
